import { render, staticRenderFns } from "./Monitoreo.vue?vue&type=template&id=96db1594"
import script from "./Monitoreo.vue?vue&type=script&lang=js"
export * from "./Monitoreo.vue?vue&type=script&lang=js"
import style0 from "./Monitoreo.vue?vue&type=style&index=0&id=96db1594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports